import React, { useContext, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { SpinnerContext } from '../../../context/spinnerContext'
import { useDispatch } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'
import { errorToast, successToast } from '../../../util/Toast/toast'
import { changePassword } from '../../../redux/slices/authSlice'
import { changePasswordSchema } from '../../../util/validationSchema'

const ChangePassword = ({ setShowChangePasswordModal }) => {
  const { changeLoader } = useContext(SpinnerContext)
  const dispatch = useDispatch()
  const [showCurrentPassword, setShowCurrentPassword] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const onCurrentPasswordEyeClick = () => setShowCurrentPassword(!showCurrentPassword)
  const onPasswordEyeClick = () => setShowPassword(!showPassword)
  const onConfirmPasswordEyeClick = () => setShowConfirmPassword(!showConfirmPassword)

  const {
    handleSubmit,
    control,
    trigger,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(changePasswordSchema)
  })

  const onSubmit = (data) => {
    if (data) {
      changeLoader(true)
      dispatch(changePassword(data)).then(({ payload }) => {
        if (payload?.status === 200) {
          successToast(payload?.data?.status_message || 'Success!')
          changeLoader(false)
          setShowChangePasswordModal(false)
        } else {
          errorToast(payload?.data?.status_message || 'Something went wrong')
          changeLoader(false)
        }
      })
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-lg-12 col-12">
          <div className="form-group input_text">
            <label className="form-control-label">Current Password</label> <span className="text-danger">*</span>
            <Controller
              name="currentPassword"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="pass-group">
                  <input
                    type={showCurrentPassword ? 'text' : 'password'}
                    className={`form-control  ${errors?.currentPassword ? 'error-input' : ''}`}
                    value={value}
                    onChange={(val) => {
                      onChange(val)
                      trigger('currentPassword')
                    }}
                    autoComplete="false"
                    placeholder="Enter Current Password"
                  />
                  <span onClick={onCurrentPasswordEyeClick} className={`fa toggle-password ${showCurrentPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
                </div>
              )}
              defaultValue=""
            />
            <small>{errors?.currentPassword?.message}</small>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-12">
          <div className="form-group input_text">
            <label className="form-control-label">New Password</label> <span className="text-danger">*</span>
            <Controller
              name="newPassword"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="pass-group">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className={`form-control  ${errors?.newPassword ? 'error-input' : ''}`}
                    value={value}
                    onChange={(val) => {
                      onChange(val)
                      trigger('newPassword')
                    }}
                    autoComplete="false"
                    placeholder="Enter Password"
                    onCopy={(e) => e.preventDefault()} // Disable copy
                    onCut={(e) => e.preventDefault()} // Disable cut
                  />
                  <span onClick={onPasswordEyeClick} className={`fa toggle-password ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
                </div>
              )}
              defaultValue=""
            />
            <small>{errors?.newPassword?.message}</small>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-12">
          <div className="form-group input_text">
            <label className="form-control-label">Confirm Password</label> <span className="text-danger">*</span>
            <Controller
              name="confirmNewPassword"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="pass-group">
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    className={`form-control  ${errors?.confirmNewPassword ? 'error-input' : ''}`}
                    value={value}
                    onChange={(val) => {
                      onChange(val)
                      trigger('confirmNewPassword')
                    }}
                    autoComplete="false"
                    placeholder="Enter Confirm Password"
                    onCopy={(e) => e.preventDefault()} // Disable copy
                    onPaste={(e) => e.preventDefault()} // Disable paste
                    onCut={(e) => e.preventDefault()} // Disable cut
                  />
                  <span onClick={onConfirmPasswordEyeClick} className={`fa toggle-password ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
                </div>
              )}
              defaultValue=""
            />
            <small>{errors?.confirmNewPassword?.message}</small>
          </div>
        </div>
      </div>

      <button className="btn btn-lg btn-block w-100 btn-primary w-100" type="submit">
        Change Password
      </button>
    </form>
  )
}

export default ChangePassword
